let
    timeoutLoader = null,
    loader = null,
    loading = false;

const
    skeletonTemplate = document.getElementById('search-result-skeleton'),
    loaderProcessing = () => {

        if (loader && !loading) {

            clearTimeout(timeoutLoader);
            timeoutLoader = setTimeout(() => {

                const boundingBox = loader.getBoundingClientRect();
                if (boundingBox.top <= (window.innerHeight || document.documentElement.clientHeight)) {

                    // loader in view zone

                    loading = true;

                    /** insert skeleton */
                    const
                        skeleton = skeletonTemplate.content.cloneNode(true),
                        workspace = document.createElement('div');

                    workspace.className = 'w-full';
                    workspace.appendChild(skeleton);

                    loader.parentNode.insertBefore(workspace, loader);

                    /** loader request */
                    const formData = new FormData();
                    // eslint-disable-next-line no-undef
                    formData.append('nonce', ajax.nonce);
                    formData.append('action', 'caranga_loader');
                    formData.append('query', loader.dataset.loader);

                    const options = {
                        method: 'POST',
                        body: formData,
                    };
                    // eslint-disable-next-line no-undef
                    fetch(ajax.url, options)
                        .then((response) => response.text())
                        .then((response) => {

                            workspace.innerHTML = response;
                            document.dispatchEvent(new CustomEvent('DOMContentUpdated', { detail: { target: workspace, isLoader: true } }));

                            const query = new URLSearchParams(loader.dataset.loader);
                            query.set('offset', parseInt(query.get('offset'), 10) + /** limit per page */ 6);

                            loader.dataset.loader = query.toString();

                            if (response) {

                                // response has content
                                loading = false;
                            }
                            else {

                                // no more posts
                                workspace.remove();
                                loader.remove();
                            }
                        });
                }
            }, 50);
        }
    },
    initLoaderProcessing = () => {

        loader = document.querySelector('[data-loader]');
        loading = false;
    };

setTimeout(() => {

    initLoaderProcessing();
    if (loader) {

        document.addEventListener('scroll', loaderProcessing);
        document.addEventListener('DOMContentUpdated', (e) => {

            if (!e.detail.isLoader)
                initLoaderProcessing();
        });
    }
}, 100);